export const GRAPH_STATUSES = {
  DRAFT: { status_id: 1, status_caption: 'Черновик' },
  ACTIVE: { status_id: 2, status_caption: 'Действующий' },
  INACTIVE: { status_id: 3, status_caption: 'Недействующий' },
}
